<div class="w-full flex flex-col gap-4 p-4">
    <div class="w-full flex sm:flex-row flex-col items-center justify-between gap-4">
        <h1 class="text-2xl font-bold">Cest</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <app-input-search
        [(ngModel)]="filtro"
        label="Pesquisar Cest"
        (keydown.enter)="filtrar()"
        (search)="filtrar()"
        class="w-full"
    ></app-input-search>

    <p-table
        (onPage)="paginate($event)"
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="totalItens"
        [value]="lista"
        [lazy]="true"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[40%] min-w-40">Descrição</th>
                <th class="w-[7%] min-w-30">Segmento</th>
                <th class="w-[10%] min-w-30">Item Segmento</th>
                <th class="w-[10%] min-w-30">Especificação</th>
                <th class="w-[10%] min-w-30">Código Cest</th>
                <th class="w-[10%] min-w-30">Ncms</th>
                <th class="w-[8%] min-w-30">Mva Original</th>
                <th class="w-[5%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.Descricao }}</td>
                <td>{{ rowData.Segmento }}</td>
                <td>{{ rowData.ItemSegmento }}</td>
                <td>{{ rowData.Especificacao }}</td>
                <td>{{ rowData.CodigoCest }}</td>
                <td>{{ rowData.Ncms }}</td>
                <td>{{ rowData.MvaOriginal }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
